<template>
  <payment-link-layout v-if="paymentLink" :isLoading="isLoading">
    <template v-slot:content>
      <asset-v3
        class="phone-icon"
        dir="icons"
        name="payment-link-phone.svg"
      />

      <h3 class="gray-900 mt-4">
        Olá, <span class="primary-500">
          {{ paymentLink.customerName | capitalize({ first: true }) }}
        </span>
      </h3>

      <h2 class="h2 gray-900" v-if="atOnboarding">Finalize sua compra</h2>
      <p v-else class="gray-900 body-regular mt-12" >
        Você recebeu um link de pagamento. Confira os dados do pedido e prossiga para
        finalizar sua compra.
      </p>

      <div class="payment-link-info mt-20 mb-24">
        <div class="paymentLinkId">
          <p class="small-regular gray-500">Nº pedido</p>
          <p class="body-semi-bold gray-900 mt-4 overflow-break">
            {{ paymentLink._id.toString() }}
          </p>
        </div>

        <div class="paymentLinkValue">
          <p class="small-regular gray-500">Valor</p>
          <p class="body-semi-bold gray-900 mt-4">{{ paymentLink.value | moneyFilter }}</p>
        </div>

        <div class="paymentLinkRetailerName">
          <p class="small-regular gray-500">Criado por</p>
          <p class="body-semi-bold gray-900 mt-4">{{ paymentLink.retailerName }}</p>
        </div>

        <div class="paymentLinkDescription">
          <p class="small-regular gray-500">Descrição</p>
          <p class="body-semi-bold gray-900 mt-4">
            {{ paymentLink.description }}
          </p>
        </div>
      </div>

      <round-checkbox
        v-if="!paymentLink.acceptedTerms"
        :textLeft="true"
        :checked="acceptedTerms"
        @click="toggleCheckBox"
        class="mb-24"
      >
        <p class="body-regular gray-900">
          Concordo com os
          <a href="https://www.parcelex.com.br/termos-de-uso" target="_blank">
            Termos de uso
          </a> e
          <a href="https://www.parcelex.com.br/politica-de-privacidade" target="_blank">
            Política de Privacidade
          </a>
          da Parcelex
        </p>
      </round-checkbox>
      <p
        v-if="!paymentLink.acceptedTerms && alreadyTryToAdvanceStep && !acceptedTerms"
        class="input-error-message mb-20"
        style="margin-top: -24px;"
      >
        Você deve concordar para continuar
      </p>
    </template>

    <template v-slot:footer>
      <round-button
        color="primary"
        @click="goToNextStep"
        content="Continuar"
      />
    </template>
  </payment-link-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import stringMixin from '@/mixins/string';
import PaymentLinkLayout from '../layout/PaymentLinkLayout.vue';
import RoundButton from '../components/RoundButton.vue';
import RoundCheckbox from '../components/RoundCheckbox.vue';

export default {
  name: 'PaymentLinkOverview',
  mixins: [stringMixin],
  components: {
    AssetV3,
    RoundButton,
    PaymentLinkLayout,
    RoundCheckbox,
  },
  data: () => ({
    nextStep: null,
    acceptedTerms: false,
    alreadyTryToAdvanceStep: false,
    isLoading: true,
  }),
  computed: {
    ...mapState('paymentLink', ['nextRoute', 'paymentLink', 'atOnboarding', 'extraQueryRoute']),
    ...mapState('onboardingV2', [
      'onboarding',
    ]),
  },
  methods: {
    ...mapActions('auth', ['setToken']),
    ...mapActions('paymentLink', ['acceptTerms', 'setLoading']),
    ...mapActions('onboardingV2', ['getOnboarding']),
    async goToNextStep() {
      if (!this.acceptedTerms) {
        this.alreadyTryToAdvanceStep = true;
        return;
      }

      if (!this.paymentLink.acceptedTerms) {
        this.setLoading({ loading: true });

        await this.acceptTerms();

        this.setLoading({ loading: false });
      }

      await this.$router.replace({
        name: this.nextRoute,
        query: {
          ...this.$route.query,
          ...this.extraQueryRoute,
        },
      });
    },
    toggleCheckBox() {
      this.alreadyTryToAdvanceStep = false;
      this.acceptedTerms = !this.acceptedTerms;
    },
  },
  async mounted() {
    this.acceptedTerms = this.paymentLink.acceptedTerms;

    if (this.extraQueryRoute) {
      const { transactionId, onboardingToken } = this.extraQueryRoute;
      await this.setToken({ token: onboardingToken });

      try {
        await this.getOnboarding({ transactionId });

        if (this.onboarding.step === 'COMPLETE') {
          const extraQueryRoute = this.extraQueryRoute || '';
          await this.$router.replace({
            name: 'v2-onboarding-complete',
            query: {
              ...this.$route.query,
              ...extraQueryRoute,
            },
          });
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.isLoading = false;
      }
    }
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .h2 {
    font-size: 28px;
    line-height: 36px;
  }

  .phone-icon {
    margin-top: 32px;
  }

  .payment-link-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr auto;
    grid-template-areas:
      "paymentLinkId paymentLinkId"
      "paymentLinkValue paymentLinkRetailerName"
      "paymentLinkDescription paymentLinkDescription";
    gap: 20px;

    .paymentLinkId {
      grid-area: paymentLinkId;
    }

    .paymentLinkValue {
      grid-area: paymentLinkValue;
    }

    .paymentLinkRetailerName {
      grid-area: paymentLinkRetailerName;
    }

    .paymentLinkDescription {
      grid-area: paymentLinkDescription;
    }

    .overflow-break {
      word-wrap: break-word;
    }

  }
</style>
